// TSS vite/04 §"Endpoint paths".
// No leading slash — axios joins baseURL + url with a single slash.
//
// Environments hang off a repository to be created and listed, but are read
// and written by their own id afterwards. That is the contract's shape, not a
// simplification made here.

export const repositoryPaths = {
    standards: () => 'admin/standards',
    standard: (id) => `admin/standards/${id}`,
    standardVersions: (id) => `admin/standards/${id}/versions`,
    standardVersion: (id) => `admin/standard-versions/${id}`,
    pinStandard: () => 'admin/standards/pin',
    list:   ()   => 'admin/repositories',
    detail: (id) => `admin/repositories/${id}`,

    environments:  (repositoryId) => `admin/repositories/${repositoryId}/environments`,
    environment:   (id)           => `admin/environments/${id}`,
    deployments:   (environmentId) => `admin/environments/${environmentId}/deployments`,
};
